<template>
	<el-drawer :modal="false" title="Account Statement" :visible.sync="is_visible" class="drawer-account-statement"
		size="60%">
		<div slot="title">
			<b-row align-h="between">
				<b-col lg="4">
					<span>Statements Details</span>
				</b-col>
				<!-- <b-col lg="6">
					<div class="d-flex align-items-center">
						<b-row no-gutters>
							<b-col cols="12" lg="6">
								<el-date-picker v-model="date_period" type="date" placeholder="Pick a day">
								</el-date-picker>
							</b-col>
							<b-col cols="12" lg="6">
								<el-button type="primary" plain size="mini" class="ml-4 float-right float-lg-none mt-2 mt-lg-0">
									<div class="d-flex align-items-center">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
											<path fill="currentColor"
												d="M12 15.575q-.2 0-.375-.062T11.3 15.3l-3.6-3.6q-.3-.3-.288-.7t.288-.7q.3-.3.713-.312t.712.287L11 12.15V5q0-.425.288-.713T12 4q.425 0 .713.288T13 5v7.15l1.875-1.875q.3-.3.713-.288t.712.313q.275.3.288.7t-.288.7l-3.6 3.6q-.15.15-.325.213t-.375.062ZM6 20q-.825 0-1.413-.588T4 18v-2q0-.425.288-.713T5 15q.425 0 .713.288T6 16v2h12v-2q0-.425.288-.713T19 15q.425 0 .713.288T20 16v2q0 .825-.588 1.413T18 20H6Z" />
										</svg>
										<p class="ml-2">Download Statement</p>
									</div>
								</el-button>
							</b-col>
						</b-row>
					</div>
				</b-col> -->
			</b-row>
		</div>
		<b-container>
			<b-row align-h="between" align-v="center" class="mx-2 mb-1">
				<b-col lg="4">
					<h3>Overview of Account Statement</h3>
				</b-col>
				<b-col lg="2">
					<p class="text-muted text-xs">Acc No: {{account_no}}</p>
				</b-col>
			</b-row>
			<b-row align-h="between" align-v="center" class="border-bottom mx-2 mb-2 pb-2">
				<b-col lg="12">
					<div class="d-flex align-items-center">
						<b-col cols="auto" class="px-1 flex-grow-1">
							<el-date-picker v-model="filters.date_end" value-format="yyyy-MM-dd" type="date" placeholder="Pick until date" @change="setFilter({date_type:'statement_date'})"></el-date-picker>
						</b-col>
						<b-col cols="auto" class="px-1">
							<el-button type="primary" plain size="large" @click="$refs.doc_statement_export.show(tableData)">
								<i class="fa fa-download"></i> Export To PDF
							</el-button>
						</b-col>
						<b-col cols="auto" class="px-1">
							<el-button type="primary" plain size="large" @click="$refs.doc_statement_export.exportToExcel(tableData)" >
								<i class="fa fa-download"></i> Export To Excel
							</el-button>
						</b-col>
					</div>
				</b-col>
			</b-row>
			<b-row class="m-3">
				<b-col cols="12">
					<b-card-group deck>
						<b-card>
							<div class="mb-2">
								<p class="text-muted text-xs">Principal Amount:</p>
								<p class="font-weight-600">RM {{ total_principal | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Total Disbursed Amount:</p>
								<p class="font-weight-600">RM {{ activeCase.disb_done_amt | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Instal. Interest (Initial)</p>
								<p class="font-weight-600">RM {{ total_interest | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Instal. Interest (UTD)</p>
								<p class="font-weight-600">RM {{ total_interest_received | moneyFormatter }}</p>
							</div>
						</b-card>
						<b-card>
							<div class="mb-2">
								<p class="text-muted text-xs">Late Charge</p>
								<p class="font-weight-600">RM {{ total_late_charge | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Late Waived</p>
								<p class="font-weight-600">RM {{ 0 | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Repayment Received</p>
								<p class="font-weight-600">RM {{ total_repayment | moneyFormatter }}</p>
							</div>
						</b-card>
						<b-card>
							<div class="mb-2">
								<p class="text-muted text-xs">Manual Rebate</p>
								<p class="font-weight-600">RM {{ total_manual_rebate | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Manual Fee Charge</p>
								<p class="font-weight-600">RM {{ total_manual_fee | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Manual Adjustment</p>
								<p class="font-weight-600">RM {{ total_manual_adjustment | moneyFormatter }}</p>
							</div>
						</b-card>
						<b-card>
							<div class="mb-2">
								<p class="text-muted text-xs">Account Balance</p>
								<p class="font-weight-600">RM {{ total_balance | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Adv. Payment Balance</p>
								<p class="font-weight-600">RM {{ total_adv_payment_balance | moneyFormatter }}</p>
							</div>
							<div class="mb-2">
								<p class="text-muted text-xs">Principal Balance</p>
								<p class="font-weight-600">RM {{ total_principal_balance | moneyFormatter }}</p>
							</div>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
			<b-card no-body>
				<div class="table-listings">
					<el-table ref="statementTable" :data="tableData" style="width: 100%" v-loading="is_loading_table">

						<el-table-column label="Date" min-width="150">
							<template slot="header">
								<span class="text-break">
									Due Date<br>
									<small>Payment Date</small>
								</span>
							</template>

							<template slot-scope="scope">
								<p class="top-line">{{ scope.row.due_date || '-' | dateFormatString }}</p>
								<p class="bottom-line">{{ scope.row.statement_date || '-' | dateFormatString }}</p>
							</template>
						</el-table-column>

						<el-table-column label="Description" min-width="350">
							<template slot="header" slot-scope="scope">
								<span class="text-break">{{ scope.column.label }}</span>
							</template>

							<template slot-scope="scope">
								<p class="top-line">{{ scope.row.category }}</p>
								<p class="bottom-line">{{ scope.row.description }}</p>
							</template>
						</el-table-column>

						<el-table-column label="Credit" min-width="150">
							<template slot="header" slot-scope="scope">
								<span class="text-break">{{ scope.column.label }}</span>
							</template>

							<template slot-scope="scope">
								<p class="top-line">RM{{ scope.row.credit | moneyFormatter }}</p>
							</template>
						</el-table-column>

						<el-table-column label="Debit" min-width="150">
							<template slot="header" slot-scope="scope">
								<span class="text-break">{{ scope.column.label }}</span>
							</template>

							<template slot-scope="scope">
								<p class="top-line">RM{{ scope.row.debit | moneyFormatter }}</p>
							</template>
						</el-table-column>

						<el-table-column label="Balance" min-width="150">
							<template slot="header" slot-scope="scope">
								<span class="text-break">{{ scope.column.label }}</span>
							</template>

							<template slot-scope="scope">
								<p class="top-line">RM{{ scope.row.balance | moneyFormatter }}</p>
							</template>
						</el-table-column>

					</el-table>
				</div>
				<!-- <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
					<div class="">
						<p class="card-category">
							Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
						</p>
					</div>
					<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
						:total="total" @change="paginationChanged($event)">
					</base-pagination>
				</div> -->
			</b-card>
			<!-- <b-row>
                <b-col cols="12">
                    <div class="card-table-simple">
                        <b-table-simple responsive borderless class="mb-0">
                            <b-thead>
                                <b-tr>
                                    <b-th>Date</b-th>
                                    <b-th>Receipt<br>No.</b-th>
                                    <b-th>Instalm.<br>Month</b-th>
                                    <b-th>Account<br>Group</b-th>
                                    <b-th>Remarks</b-th>
                                    <b-th>Credit<br>(RM)</b-th>
                                    <b-th>Debit<br>(RM)</b-th>
                                    <b-th>Balance<br>(RM)</b-th>
                                    <b-th>Adv. Payment<br>(RM)</b-th>
                                    <b-th>Adv. Payment<br>Balan.(RM)</b-th>
                                    <b-th>Outstand.<br> Pcp. (RM)</b-th>
                                    <b-th>Outstand. Pcp.<br>Balance(RM)</b-th>
                                    <b-th>Outstand.<br> Interest (RM)</b-th>
                                    <b-th>Outstand. Int.<br>Balance(RM)</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(data, index) in tableData" :key="index">
                                    <b-td>{{ data.date }}</b-td>
                                    <b-td>{{ data.receipt_no }}</b-td>
                                    <b-td>{{ data.instalm_month }}</b-td>
                                    <b-td>{{ data.acc_grp }}</b-td>
                                    <b-td>{{ data.remarks }}</b-td>
                                    <b-td>{{ data.credit | moneyFormatter }}</b-td>
                                    <b-td>{{ data.debit | moneyFormatter }}</b-td>
                                    <b-td>{{ data.balance | moneyFormatter }}</b-td>
                                    <b-td>{{ data.adv_payment | moneyFormatter }}</b-td>
                                    <b-td>{{ data.adv_payment_bal | moneyFormatter }}</b-td>
                                    <b-td>{{ data.outstand_pcp | moneyFormatter }}</b-td>
                                    <b-td>{{ data.outstand_pcp_bal | moneyFormatter }}</b-td>
                                    <b-td>{{ data.outstand_interest | moneyFormatter }}</b-td>
                                    <b-td>{{ data.outstand_interest_bal | moneyFormatter }}</b-td>
                                </b-tr>
                            </b-tbody>
                            <b-tfoot>
                                <b-tr class="bg-warning">
                                    <b-td class="text-weight-600" colspan="5">Total</b-td>
                                    <b-td class="text-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 9853.34 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 9833.34 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                    <b-td class="text-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                </b-tr>
                            </b-tfoot>
                        </b-table-simple>
                    </div>
                </b-col>
            </b-row> -->
		</b-container>
		<DocStatementExport ref="doc_statement_export" />
	</el-drawer>
</template>
<script>
import { cloneDeep } from 'lodash'
import { Table, TableColumn, Drawer, Button, DatePicker } from 'element-ui'
// import ExcelJS from 'exceljs';
import DocStatementExport from '@/views/CreditLoanCase/DocTemplate/DocStatementExport';
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	mixins: [clientPaginationMixin],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Drawer.name]: Drawer,
		[Button.name]: Button,
		[DatePicker.name]: DatePicker,
		DocStatementExport
	},
	data() {
		return {
			is_visible: false,
			is_loading_table: false,
			date_period: '',
			tableData: [],
			filters:{
				date_type: '',
				date_start: '',
				date_end: '',
			}
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeStatements','activeCase','activeRepayments']),
		account_no(){
			let alt = _gHlp.formatDate(_gHlp.getValue(this.activeCase,'created_at',''),'Ymd')+''+ _gHlp.getValue(this.activeCase,'case_id','');
			return _gHlp.getValue(this.activeCase,'account_no',alt); 
		},
		actual_installment(){
		 const loan_amount = _gHlp.getValue(this.activeCase,'loan_amount',0)
		 const interest_rate = _gHlp.getValue(this.activeCase,'interest_rate',0)
		 const tenure_year = _gHlp.getValue(this.activeCase,'loan_tenure_year',0)
		 let month = tenure_year * 12;
		 let total = 0;
		 if(['STL','FEL'].includes(_gHlp.getValue(this.activeCase,'loan_type_code'))){
				total = ((parseFloat(loan_amount) * (parseFloat(interest_rate) / 100)) + parseFloat(loan_amount)) / parseInt(month);
		 }else{
			 total = (((parseFloat(loan_amount) * (parseFloat(interest_rate) / 100)) * tenure_year) + parseFloat(loan_amount)) / parseInt(month);
		 }
		 return parseFloat(total).toFixed(2);
		},
		total_principal(){
			return this.activeRepayments.reduce((acc, item) => {
				const amount = parseFloat(item.principal_amt);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_interest(){
			return this.activeRepayments.reduce((acc, item) => {
				const amount = parseFloat(item.interest_amt);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_late_charge(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.LATE_CHARGES)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total.toFixed(2))
		},
		total_interest_received(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.INTEREST)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total.toFixed(2))
		},
		total_interest_qty(){
			if(['STL','FEL'].includes(_gHlp.getValue(this.activeCase,'loan_type_code'))){
				return _gHlp.getValue(this.activeCase,'loan_tenure')
			}
			let interest = this.tableData.filter((x)=> x.category === _gConst.paymentCategory.INTEREST)
			return interest.length ?? 0
		},
		total_repayment(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || ![_gConst.paymentCategory.REPAYMENT,_gConst.paymentCategory.REDEMPTION,_gConst.paymentCategory.ADVANCE_PAYMENT].includes(item.category)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			// return parseFloat(total).toFixed(2) - parseFloat(this.total_manual_fee) + parseFloat(this.total_manual_rebate);
			return parseFloat(total).toFixed(2);
		},
		total_redemption(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || ![_gConst.paymentCategory.REDEMPTION].includes(item.category)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total).toFixed(2);
		},
		total_manual_rebate(){
			return this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.MANUAL_REBATE)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_manual_fee(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.MANUAL_FEE_CHARGE)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total.toFixed(2))
		},
		total_manual_adjustment(){
			return this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.MANUAL_ADJUSTMENT)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_late_waived(){
			return this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.LATE_WAIVED)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_adv_payment_balance(){
			let total = parseFloat(this.total_credit) - parseFloat(this.total_debit);
			return total >= 0 ? 0 : (total * -1);
		},
		total_credit() {
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);

			return parseFloat(total.toFixed(2))
		},
		total_debit() {
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total.toFixed(2))
		},
		total_balance() {
			return parseFloat(this.total_credit) - parseFloat(this.total_debit);
		},
		total_principal_amt_received(){
			return (this.total_interest_qty * parseFloat(this.actual_installment)) - parseFloat(this.total_interest_received);
		},
		total_principal_balance(){
			const d = parseFloat(_gHlp.getValue(this.activeCase, 'disb_done_amt', 0))
			const i = parseFloat(this.total_interest_received)
			return (d+i) - parseFloat(this.total_manual_rebate) -  parseFloat(this.total_repayment);
		},
  },
	methods: {
		...mapActions(useLoanCaseStore, ['getStatementList']),
		show() {
			this.resetFilter();
			this.is_visible = true;
		},
		getFilters(){
			let filtered = {};
			let obj = this.filters;
			Object.keys(obj).forEach(key => {
					if (!_gHlp.isEmpty(obj[key])) {
							filtered[key] = obj[key];
					}
			});
			return filtered;
		},
		setFilter(obj){
			this.filters = { ...this.filters, ...obj }
			this.getListing()
		},
		resetFilter() {
			Object.keys(this.filters).forEach(key => {
				this.filters[key] = ''
			});
			this.setFilter({})
		},
		async getListing() {
			this.is_loading_table = true;
			const params = {
				search: this.getFilters(),
				paginate: 'no_paginate'
				// paginate: this.pagination.perPage,
				// page: (resetPage) ? 1 : this.pagination.currentPage
			};
			const dataList = await this.getStatementList(params);

			//INJECT CUSTOMER DETAIL
			this.tableData = dataList.data
			this.tableSummary = dataList.summary;
			this.pagination = dataList.pagination;
			this.is_loading_table = false;
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
			this.getListing();
		}
	}
}
</script>